




















import Vue from 'vue';
import { VBTooltip, BFormGroup } from 'bootstrap-vue';

export default Vue.extend({
  name: 'ZenFormGroup',
  components: {
    BFormGroup,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    emptyLabel(): boolean {
      return !this.noLabel && !this.label;
    },
  },
});
